import { useSearchParams } from 'react-router-dom'
import { Select, TabLabel, TabLabelsList } from '@/ui'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import { TABS } from './tabs'

interface SettingsTabLabelsProps {
  isAdmin?: boolean
  defaultTab: string
}

export const SettingsTabLabels = ({
  isAdmin,
  defaultTab,
}: SettingsTabLabelsProps) => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  const [searchParams, setSearchParams] = useSearchParams()

  const tabs = [
    { id: TABS.ACCOUNT, title: 'Account' },
    ...(isAdmin
      ? []
      : [
          { id: TABS.FINANCIAL_INSTITUTIONS, title: 'Financial Institutions' },
          { id: TABS.PLAN_AND_BILLING, title: 'Plan and Billing' },
        ]),
  ]

  if (isMobile) {
    const tabParam = searchParams.get('tab')
    const activeTab = tabs.find(({ id }) => id === tabParam)?.id ?? defaultTab
    return (
      <div className="mb-6">
        <Select
          value={activeTab}
          options={tabs.map(({ id, title }) => ({ value: id, text: title }))}
          onValueChange={(value) =>
            setSearchParams({ tab: value }, { replace: true })
          }
        />
      </div>
    )
  }

  return (
    <TabLabelsList>
      {tabs.map(({ id, title }) => (
        <TabLabel key={id} id={id} title={title} />
      ))}
    </TabLabelsList>
  )
}
